import { colors } from '../../../stylesheets';

export const setTextColor = ({ color }) =>
  color ? { color: colors[color] || color } : {};
